import React, { useState, useContext, useEffect } from 'react'
import styles from './Lpdp.module.css'
import Subtitle from '../../components/Subtitle/Subtitle'
import Footer from '../../components/Footer'
import Header from '../../components/Header'
import Modal from '../../components/Modals'

import SubMenu from '../../components/SubMenu'
import GeneralContext from '../../context/GeneralContext'
import * as GeneralActions from '../../store/actions/generalActions'

//Services
import * as SolicitudMultipleRepository from "../../services/repositories/solicitud-multiple-repository";
import * as SolicitudRepository from "../../services/repositories/solicitud-repository";

const Lpdp = ({ history }) => {
    const { state: generalState, dispatch: generalDispatch } = useContext(GeneralContext)
    let user = generalState.users.filter(user => user.isAuthenticated)[0]
    let prospecto = user.listaProspectos.filter(prospecto => prospecto.isSelected)[0]
    let cotizacion = prospecto.cotizaciones.filter(cotizacion => cotizacion.isSelected || cotizacion.completado)[0]

    const textos = ['¡Alerta!', 'Debes marcar una opción "Si" o "No" para continuar']
    const [mostrarModal, setModal] = useState(false)

    const initialState = {
        estaCargando: true,
        errorCargando: null,
        valorModal: null,
        valorModalAdicional: null,
        codigoEstado: null,
        reloadValidacion: false,
        esAseguradoAdicional: false
    }

    const [state, setState] = useState(initialState)

    const mostrarPopup = () => {
        setModal(!mostrarModal)
    }

    const handleChange = e => {
        const isValue = e.target.value === 'true' ? true : false
        setState((state) => {
            return {
                ...state,
                valorModal: isValue
            }
        })
    }

    const handleChangeAdicional = e => {
        const isValue = e.target.value === 'true' ? true : false
        setState((state) => {
            return {
                ...state,
                valorModalAdicional: isValue
            }
        })
    }

    const putSolicitudes = async () => {
        const response = await SolicitudRepository.actualizarSolicitud(
            cotizacion.idSolicitudMultiple,
            (state.valorModal === false ? 2 : state.valorModal === true ? 1 : null),
            (state.valorModalAdicional === false ? 2 : state.valorModalAdicional === true ? 1 : null),
            null)
        if(response.error === null) {
            return true
        } else {
            return false
        }
    }

    const validarPantalla = async() => {
        if (state.valorModal === undefined || state.valorModal === null) {
            mostrarPopup()
            return false
        }
        else if (state.esAseguradoAdicional && (state.valorModalAdicional === undefined || state.valorModalAdicional === null)) {
            mostrarPopup()
            return false
        } else {
            //Se setea, adicional, el codigo de estado
            generalDispatch(
                GeneralActions.updateLpdpProspecto(
                    state.valorModal === false ? 2 : state.valorModal === true ? 1 : null, 
                    state.valorModalAdicional === false ? 2 : state.valorModalAdicional === true ? 1 : null, 
                    state.codigoEstado
                )
            )
            let respuesta = await putSolicitudes()
            if (respuesta) { return true }
            else { return false }
        }
    }

    const obtenerCodigoEstado = async () => {
        const response = await SolicitudMultipleRepository.obtenerEstadoSolicitudMultiple(cotizacion.idSolicitudMultiple)
        if(response.error === null) {
            setState((state) => {
                return {
                    ...state,
                    estaCargando: false,
                    codigoEstado: response.estado
                }
            })
        } else {
            generalDispatch(GeneralActions.updateError(response.error, '¡Alerta!', true))
        }
    }

    const flagEsAseguradoAdicional = async () => {
        let esAseguradoAdicional = false
        cotizacion.solicitudes.map(solicitud => {
            esAseguradoAdicional = solicitud.indicadorAseguradoAdicional
        })
        setState((state) => {
            return {
                ...state,
                esAseguradoAdicional: esAseguradoAdicional
            }
        })
    }

    const cargarDatosIniciales = async () => {
        generalDispatch(GeneralActions.updateEstadoCargando(true))
        await obtenerCodigoEstado()
        generalDispatch(GeneralActions.updateEstadoCargando(false))
        await flagEsAseguradoAdicional()
    }

    useEffect(() => {
        setState((state) => {
            return {
                ...state,
                estaCargando: true,
                errorCargando: null,
                valorModal: cotizacion.lpdp === 2 ? false : cotizacion.lpdp === 1 ? true : null,
                valorModalAdicional: cotizacion.lpdpAdicional === 2 ? false : cotizacion.lpdpAdicional === 1 ? true : null
            }
        })

        cargarDatosIniciales()
    }, [])

    //Modo lectura
    let Deshabilitar = (complete) => {
        complete = cotizacion.edicionInhabilitada
        if (complete === true && complete !== undefined) {
            return true
        } else {
            return false
        }
    }

    const [mover, setMover] = useState(false)
    const mueveContenido = (valor) => {
        setMover(valor)
    }

    return (
        <div>
            <Header
                history={history}
            />
            <SubMenu history={history} modal={state.estaCargando || mostrarModal} desplaza={mueveContenido} />
            <section className={styles['areadatosusuario']}
                style={mover ? {width: '93%', paddingLeft: '6.5%', height: '100vh'} : {}}
            >
                <div className={styles['areadatosprospecto']}>
                    <Subtitle
                        sname="Ley de Protección de Datos Personales"
                    />
                    <div>
                        <Modal
                            mostrarModal={mostrarModal}
                            setModal={setModal}
                            textos={textos}
                        />
                    </div>
                    <div className={styles['arealeydatos']}>
                        <h3>Cláusulas de usos adicionales y transferencia de información</h3>
                        <p className={styles['dataley']}>Autorizas que Pacífico Seguros, de manera directa o a través de sus encargados de tratamiento, te oferte y/o remita por cualquier medio escrito, verbal, electrónico y/o informático lo siguiente:</p>
                        <p className={styles['dataley']}></p>
                        <p className={styles['dataley']}>    • Los productos y servicios que brindamos, tales como seguros o cualquier otro que desarrollemos en el futuro. <br />
                            • Información sobre los beneficios y programas de fidelización que Pacífico Seguros o nuestros aliados comerciales, cuyo listado se encuentra disponible en <a href={'https://www.pacifico.com.pe/documents/28730/0/lista+empresas+socios+comerciales.pdf/9719c164-8656-5a49-8261-5d17dbb973bd?t=1682088020155'} rel="nopener noreferrer" target={'_blank'}> Lista empresas socios comerciales (pacifico.com.pe)</a>, tienen para ti.<br />
                            • La posibilidad de participar en estudios, investigaciones de mercado, encuestas y/o focus groups.<br />
                        </p>
                        <p className={styles['dataley']}>Las comunicaciones o mensajes con la información, ofertas y/o publicidades podrán ser remitidas a través de medios escritos (por ejemplo, comunicaciones físicas), verbales (por ejemplo, mensajes de voz o llamadas telefónicas) o electrónicos/informáticos (por ejemplo, mensajes de texto, notificaciones push, WhatsApp, correo electrónico u otras plataformas de mensajería).</p>
                        <p className={styles['dataley']}>Asimismo, autorizas que tus datos sean tratados para realizar un análisis de riesgos y siniestralidad para la contratación de cualquier póliza de seguros, así como para el análisis de los siniestros y determinación de la cobertura y cuantía de estos mismos. Para ello, nos autorizas a entregarle a las <a href={'https://www.pacifico.com.pe/documents/28730/96653363/Lista+empresas+socios+aseguradoras+y+su+gremio.pdf/35a7e09c-6530-5d68-519b-55586fb2df26?from=GoogleBT'} rel="nopener noreferrer" target={'_blank'}>Empresas Aseguradoras y su gremio</a>, cuando así lo requieran en virtud de una solicitud de contratación y/o de cotización de una póliza de seguros, así como por la ocurrencia de un siniestro y/o el riesgo de que el mismo ocurra, información acerca de (i) la existencia de seguros contratados por ti con las Empresas Aseguradoras; y, (ii) las sumas aseguradas y principales condiciones de cobertura. También, y para esta misma finalidad, autorizas a Pacífico Seguros a requerir esta información de las Empresas Aseguradoras y su gremio para cumplir con esta misma finalidad cuando se requiera la contratación y/o cotización de una póliza de seguros, así como para el análisis de los siniestros y la determinación de la cobertura y cuantía de estos mismos. Los resultados del análisis que se realice podrán ser compartidos por Pacífico Seguros con las Empresas Aseguradoras y su gremio, y viceversa.</p>
                        <p className={styles['dataley']}>Pacífico Seguros podrá transferir tu información a las empresas del Grupo Credicorp y socios comerciales (“Terceros Autorizados”) cuya identidad y ubicación aceptas haber tenido a tu disposición al momento de contratar, y que también se encuentra disponible en <a href={'https://www.pacifico.com.pe/documents/28730/0/lista+empresas+socios+comerciales.pdf/9719c164-8656-5a49-8261-5d17dbb973bd?t=1682088020155'} rel="nopener noreferrer" target={'_blank'}> Lista empresas socios comerciales (pacifico.com.pe).</a> Los Terceros Autorizados podrán usar tu información, directamente o a través de encargados, para realizar estudios de mercado, perfiles de compra, envío de publicidad, promociones y ofertas de los productos y/o servicios que ofrecen, y ejecutar o preparar las relaciones comerciales que podrían mantener contigo.</p>
                        <p className={styles['dataley']}>Asimismo, nos autorizas a solicitar a las empresas del Grupo Credicorp, y a éstas a trasferirnos, los datos personales de tu titularidad que tuvieren. Ello a fin de cumplir con las finalidades descritas en la presente autorización. Mediante la emisión de esta autorización reconoces haber recibido información relevante de las empresas del Grupo Credicorp que se mantienen a tu disposición en el siguiente enlace <a href={'https://www.pacifico.com.pe/documents/28730/0/lista+empresas+socios+comerciales.pdf/9719c164-8656-5a49-8261-5d17dbb973bd?t=1682088020155'} rel="nopener noreferrer" target={'_blank'}> Lista empresas socios comerciales (pacifico.com.pe).</a></p>
                        <p className={styles['dataley']}>Declaras tener conocimiento que (i) fruto de la transferencia de la información entre Pacífico Seguros y los Terceros Autorizados, tu información podrá ser enriquecida a través de fuentes públicas y/o privadas; y, (ii) dicha información enriquecida podrá ser compartida entre Pacífico Seguros y los Terceros Autorizados.</p>
                        <p className={styles['dataley']}>Pacífico Seguros y los Terceros Autorizados podrán conservar y tratar tu información en los términos establecidos en esta autorizacipon, mientras se mantenga nuestra relación contractual y luego de veinte (20) años de finalizada la misma.</p>
                        <p className={styles['dataley']}>Pacífico Seguros podrá modificar los términos de la presente autorización, para lo cual deberá informarte con una anticipación mínima de 45 días calendario, a partir de los cuales la modificación surtirá efecto. En caso no estés de acuerdo con la modificación realizada, podrás revocar el consentimiento a través de los medios que hemos puesto a tu disposición. Cualquier modificación unilateral que realicemos no podrá tener relación directa con datos sensibles (como por ejemplo, datos biométricos, ingresos económicos, información de salud), según estos han sido regulados en la Ley 29733 - Ley de Protección de Datos Personales y su Reglamento aprobado por el Decreto Supremo 3-2013-JUS.</p>
                        <p className={styles['dataley']}>A esta autorización le resultan aplicables los términos señalados en la sección informativa del Tratamiento de tus Datos Personales, así como lo indicado en nuestra <a href={'https://www.pacifico.com.pe/transparencia/politica-privacidad#privacidad'} rel="nopener noreferrer" target={'_blank'}>Política de Privacidad</a>.</p>
                        <p className={styles['dataley']}>La aceptación o no de esta autorización para “Usos Adicionales y Transferencia de Información” (ajenos a la ejecución de la relación contractual) no condiciona la prestación del servicio que hayas contratado.</p>
                    </div>


                    { 
                        state.esAseguradoAdicional ?
                            <div className={styles['arealeydatosMarcar']}>
                                <div className={styles['arealeydatosMarcarAsesor']} >
                                    <p className={styles['areadatosprospecto__subtitulo_info']}><b>Asegurado principal</b></p>
                                    <div className={styles['arealeydatosMarcarAsesorTerminos']}>
                                        <p className={styles['areadatosprospecto__subtitulo_info']}>Acepto los T&eacute;rminos y Condiciones.</p>
                                        <div className={styles['optionlight']}>
                                            <label>
                                                <input
                                                    type="radio"
                                                    name="light"
                                                    value="true"
                                                    checked={state.valorModal === true}
                                                    selected={state.valorModal === true}
                                                    onChange={handleChange}
                                                    disabled={Deshabilitar() !== true ? false : true}
                                                />
                                                <span className="span-radio-si-no">Si</span>
                                            </label>
                                            <label>
                                                <input
                                                    type="radio"
                                                    name="light"
                                                    value="false"
                                                    checked={state.valorModal === false}
                                                    selected={state.valorModal === false}
                                                    onChange={handleChange}
                                                    disabled={Deshabilitar() !== true ? false : true}
                                                />
                                                <span className="span-radio-si-no">No</span>
                                            </label>
                                        </div> 
                                    </div>
                                </div>

                                <div className={styles['arealeydatosMarcarAsesor']} >
                                    <p className={styles['areadatosprospecto__subtitulo_info']}><b>Asegurado adicional</b></p>
                                    <div className={styles['arealeydatosMarcarAsesorTerminos']}>
                                        <p className={styles['areadatosprospecto__subtitulo_info']}>Acepto los T&eacute;rminos y Condiciones.</p>
                                        <div className={styles['optionlight']}>
                                            <label>
                                                <input
                                                    type="radio"
                                                    name="lightAdicional"
                                                    value="true"
                                                    checked={state.valorModalAdicional === true}
                                                    selected={state.valorModalAdicional === true}
                                                    onChange={handleChangeAdicional}
                                                    disabled={Deshabilitar() !== true ? false : true}
                                                />
                                                <span className="span-radio-si-no">Si</span>
                                            </label>
                                            <label>
                                                <input
                                                    type="radio"
                                                    name="lightAdicional"
                                                    value="false"
                                                    checked={state.valorModalAdicional === false}
                                                    selected={state.valorModalAdicional === false}
                                                    onChange={handleChangeAdicional}
                                                    disabled={Deshabilitar() !== true ? false : true}
                                                />
                                                <span className="span-radio-si-no">No</span>
                                            </label>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        :
                            <div>
                                <p className={styles['areadatosprospecto__subtitulo_info']}>Marque SI o NO</p>
                                    <div className={styles['optionlight']}>
                                        <label>
                                            <input
                                                type="radio"
                                                name="light"
                                                value="true"
                                                checked={state.valorModal === true}
                                                selected={state.valorModal === true}
                                                onChange={handleChange}
                                                disabled={Deshabilitar() !== true ? false : true}
                                            />
                                            <span className="span-radio-si-no">Si</span>
                                        </label>
                                        <label>
                                            <input
                                                type="radio"
                                                name="light"
                                                value="false"
                                                checked={state.valorModal === false}
                                                selected={state.valorModal === false}
                                                onChange={handleChange}
                                                disabled={Deshabilitar() !== true ? false : true}
                                            />
                                            <span className="span-radio-si-no">No</span>
                                        </label>
                                    </div>    
                            </div>
                    }
                </div>
                <Footer history={history} validarPantalla={validarPantalla} />
            </section>
        </div>
    )
}

export default Lpdp